import { render, staticRenderFns } from "./productoEstrategicos.vue?vue&type=template&id=48ae9cfc&"
import script from "./productoEstrategicos.vue?vue&type=script&lang=js&"
export * from "./productoEstrategicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports